import { render, staticRenderFns } from "./VirtualColumn.vue?vue&type=template&id=8aafa2aa&scoped=true"
import script from "./VirtualColumn.vue?vue&type=script&lang=js"
export * from "./VirtualColumn.vue?vue&type=script&lang=js"
import style0 from "./VirtualColumn.vue?vue&type=style&index=0&id=8aafa2aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aafa2aa",
  null
  
)

export default component.exports